import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import { colorStyling } from "helpers/color";
import { lineConfig } from "../helper/lineConfig";
import SrgLinesUpdateStatusButton from "./SrgLinesUpdateStatusButton";

const SrgLinesItem = ({ data, index, permission }) => {
  const { t } = useTranslation("srgLines");

  const capsuleCode = (data) => {
    return (
      <Box width={"100%"} display={"flex"} justifyContent={"center"}>
        <Box
          display={"flex"}
          justifyContent={"center"}
          sx={{
            backgroundColor: lineConfig[data?.code]?.color,
            color: lineConfig[data?.code]?.contrastText,
            width: "50px",
            height: "25px",
            borderRadius: "25px",
          }}
        >
          <Box sx={{ pt: "2px" }}>{lineConfig[data?.code]?.abbr}</Box>
        </Box>
      </Box>
    );
  };

  const statusField = (status) => {
    return (
      <Box
        display="flex"
        justifyContent={"flex-start"}
        alignItems={"center"}
        gap={"8px"}
      >
        <img
          width={"25px"}
          height={"25px"}
          src={"/assets/" + status + ".png"}
          alt={t("status." + data?.status) + "Icon"}
        />
        <Box>{t("status." + data?.status)}</Box>
      </Box>
    );
  };
  return (
    <>
      <TableRow
        sx={{
          ...((index + 1) % 2 !== 0
            ? {
                backgroundColor: colorStyling.white.hover,
              }
            : {
                backgroundColor: colorStyling.white.full,
              }),
        }}
      >
        <TableCell>{capsuleCode(data)}</TableCell>
        <TableCell>{data?.name}</TableCell>
        <TableCell>{statusField(data?.status)}</TableCell>
        <TableCell>
          <EllipsisTooltip
            text={data?.info === "" ? "—" : data?.info}
            lines={3}
          />
        </TableCell>
        <TableCell align="center">
          <SrgLinesUpdateStatusButton
            data={data}
            disabled={!permission?.updateLineStatus}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

const EllipsisTooltip = ({ text, lines = 3, sx = {} }) => {
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const checkOverflow = () => {
    const el = textRef.current;
    if (!el) return;

    const isOverflowing =
      el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;

    setShowTooltip(isOverflowing);
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [text]);

  return (
    <Tooltip title={text} disableHoverListener={!showTooltip} arrow>
      <Box
        ref={textRef}
        sx={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: lines,
          overflow: "hidden",
          ...sx,
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
};

export default SrgLinesItem;
